function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M27.066 5.8223C25.0026 2.26134 21.3375 0.0857996 17.2618 0.00265894C17.0878 -0.000927002 16.9127 -0.000927002 16.7386 0.00265894C12.663 0.0857996 8.99791 2.26134 6.93441 5.8223C4.82521 9.46216 4.7675 13.8343 6.78001 17.518L15.2111 32.9499C15.2149 32.9568 15.2187 32.9636 15.2226 32.9704C15.5936 33.6151 16.2581 34 17.0003 34C17.7425 34 18.407 33.615 18.7779 32.9704C18.7818 32.9636 18.7856 32.9568 18.7894 32.9499L27.2205 17.518C29.2329 13.8343 29.1752 9.46216 27.066 5.8223ZM17.0002 15.4063C14.3638 15.4063 12.2189 13.2614 12.2189 10.625C12.2189 7.98861 14.3638 5.84375 17.0002 5.84375C19.6366 5.84375 21.7814 7.98861 21.7814 10.625C21.7814 13.2614 19.6367 15.4063 17.0002 15.4063Z",
  fill: "#D1D1D1"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 34,
  height: 34,
  fill: "white"
})));

function SvgLocation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.55e318a5.svg";
export { ForwardRef as ReactComponent };